// extracted by mini-css-extract-plugin
export default {"nav":"PageTabs_nav__J5wP8","text":"PageTabs_text__4B3Nx","activeTab":"PageTabs_activeTab__+Hb9L","border":"PageTabs_border__EsIOs"};